"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _Phone = _interopRequireDefault(require("@material-ui/icons/Phone"));

var _Email = _interopRequireDefault(require("@material-ui/icons/Email"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    avatar: {
      backgroundColor: theme.palette.primary.main
    },
    media: {
      paddingTop: '50%'
    }
  };
});

var ContactCard = function ContactCard(_ref) {
  var className = _ref.className,
      avatarUrl = _ref.avatarUrl,
      fullName = _ref.fullName,
      subheader = _ref.subheader,
      action = _ref.action,
      phone = _ref.phone,
      email = _ref.email,
      children = _ref.children,
      onClick = _ref.onClick;
  var classes = useStyles();

  var cardContent = /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.CardHeader, {
    avatar: /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
      "aria-label": "Recipe",
      className: classes.avatar,
      src: avatarUrl
    }),
    title: fullName,
    subheader: subheader,
    action: action || (email != null ? /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
      title: email
    }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
      "aria-label": "settings"
    }, /*#__PURE__*/_react["default"].createElement(_Email["default"], null))) : phone && /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
      title: phone
    }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
      "aria-label": "settings"
    }, /*#__PURE__*/_react["default"].createElement(_Phone["default"], null))))
  }), children || '');

  if (onClick) {
    return /*#__PURE__*/_react["default"].createElement(_core.Card, {
      className: (0, _classnames["default"])(className, classes.root)
    }, /*#__PURE__*/_react["default"].createElement(_core.CardActionArea, {
      onClick: onClick
    }, cardContent));
  }

  return /*#__PURE__*/_react["default"].createElement(_core.Card, {
    className: (0, _classnames["default"])(classes.root)
  }, cardContent);
};

ContactCard.propTypes = {
  className: _propTypes["default"].string,
  avatarSrc: _propTypes["default"].string,
  fullName: _propTypes["default"].string.isRequired,
  subheader: _propTypes["default"].string,
  phone: _propTypes["default"].string,
  email: _propTypes["default"].string,
  action: _propTypes["default"].node
};
ContactCard.defaultProps = {
  className: ''
};
var _default = ContactCard;
exports["default"] = _default;